module.exports = __webpack_public_path__ + "assets/img/swiper-1-5.1ba8ecf3.jpg";